import React from "react";

import {
  Card,
  CardBody,
  // Title,
  Content
} from "@patternfly/react-core";

import MegaMenuLink from "../MegaMenuLink/MegaMenuLink";

import { logosService } from "../../../top/services/logosService";
import useAppearance from "shared/appearance/hooks/useAppearance";
import { LOGO_SIZES } from "../../../../../../../shared/constants/logoSizes";

import "./MegaMenuCard.css";

const MegaMenuCard = ({ section }) => {
  const { colorScheme } = useAppearance();

  const logo = section.logoId
    ? logosService.getLogo(section.logoId, {
        colorScheme,
      })
    : null;

  return (
    <Card
      isPlain
      className="school-mega-menu-card"
    >
      <CardBody>
        {logo ? (
          <div className="school-mega-menu-card__logo">
            <img
              src={logo.src}
              alt={logo.alt ?? section.title}
              style={{
                height: `${
                  logo.height ??
                  LOGO_SIZES.desktop[logo.size]
                }px`,
                width: "auto",
                display: "block",
                ...(logo.offset && {
                  transform: `translate(
                    ${logo.offset.x}px,
                    ${logo.offset.y}px
                  )`,
                }),
              }}
            />
          </div>
        ) : (
          <Content
            component="p"
            className="school-mega-menu-card__title"
          >
            {section.title}
          </Content>
        )}

        <div className="school-mega-menu-card__links">
          {[...section.links]
            .sort((a, b) => a.order - b.order)
            .map((link) => (
              <MegaMenuLink
                key={link.id}
                link={link}
              />
            ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default MegaMenuCard;